import { ApiService } from "./api.service";
import { Money } from "../helpers/money";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";

export default class TBAService extends ApiService {
  namespace = "to-be-approved";
  listingRelations = "submitterName,amount";
  DOMAIN = DOMAIN.TO_BE_APPROVED;
  name = "To Be Approved";
  template = "defaultTemplate";
  Width = 1250;
  icon = "Check";
  favicon = "Check";
  singular = this.terminology.tba.singular;
  plural = this.terminology.tba.plural;
  vowel = this.terminology.tba.vowel;
  relations =
    "?expand=submitterName,amount,batches,batches.items,batches.items.billNumber";

  columns = [
    {
      header: this.t("Number"),
      icon: AppIcons.SHRED,
      field: "id",
    },
    {
      header: "Submitted By",
      icon: AppIcons.USER_SILHOUETTE,
      field: "submitterName",
    },
    {
      header: "Date",
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      template: (data) => {
        return this.parseDateMoment(data["submit_date"]);
      },
    },
    {
      header: "Status",
      icon: AppIcons.LIGHTNING,
      field: "status",
      template: (data) => {
        return this.statuses(data["status"]);
      },
    },
    {
      header: this.t("Amount"),
      icon: AppIcons.MONEY,
      field: "amount",
      template: (amount) => {
        return Money.format(amount["amount"]);
      },
    },
    {
      header: this.t("Decided By"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "decided_by",
    },
  ];

  listMenuItems = [
    {
      key: "edit",
      label: "Open this TBA Batch...",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: DOMAIN.MESSAGES,
      icon: AppIcons.LIST,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
  ];
  permissions = [
    {
      key: "pending",
      display_name: "Pending",
      icon: AppIcons.CLOCK,
      section: 2,
    },

    {
      key: "approved",
      display_name: "Approved",
      icon: AppIcons.CHECK,
      section: 3,
    },
    {
      key: "reject",
      display_name: "Reject",
      icon: AppIcons.CROSS,
      section: 4,
    },
  ];
  constructor() {
    super("ap-tbas");
  }
}
